/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bubble_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The radius is scaled by the square root of the size value, so the bubble's area — which is what the eye judges — is proportional to the value.`)
};

const es_bubble_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El radio se escala por la raíz cuadrada del valor de tamaño, de modo que el área de la burbuja — que es lo que el ojo juzga — sea proporcional al valor.`)
};

const de_bubble_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Radius wird mit der Quadratwurzel des Größenwerts skaliert, sodass die Fläche der Blase — die vom Auge beurteilt wird — proportional zum Wert ist.`)
};

const nl_bubble_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De straal wordt geschaald met de vierkantswortel van de groottewaarde, zodat het oppervlak van de bel — wat het oog beoordeelt — evenredig is met de waarde.`)
};

const fr_bubble_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le rayon est mis à l'échelle par la racine carrée de la valeur de taille, de sorte que l'aire de la bulle — ce que l'œil perçoit — soit proportionnelle à la valeur.`)
};

const it_bubble_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il raggio è scalato in base alla radice quadrata del valore della dimensione, così l'area della bolla — che è ciò che l'occhio giudica — è proporzionale al valore.`)
};

const pt_br2_bubble_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O raio é escalado pela raiz quadrada do valor de tamanho, de modo que a área da bolha — que é o que o olho percebe — seja proporcional ao valor.`)
};

const pt_bubble_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O raio é dimensionado pela raiz quadrada do valor do tamanho, para que a área da bolha — que é o que o olho avalia — seja proporcional ao valor.`)
};

const ja_bubble_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`半径はサイズ値の平方根でスケールされるため、目で判断される面積が値に比例します。`)
};

const zh_bubble_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`半径按大小数值的平方根进行缩放，因此气泡的面积——也就是肉眼所判断的——与数值成比例。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bubble_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bubble_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bubble_faq_a2", locale)
	if (locale === "en") return en_bubble_faq_a2(inputs)
	if (locale === "es") return es_bubble_faq_a2(inputs)
	if (locale === "de") return de_bubble_faq_a2(inputs)
	if (locale === "nl") return nl_bubble_faq_a2(inputs)
	if (locale === "fr") return fr_bubble_faq_a2(inputs)
	if (locale === "it") return it_bubble_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_bubble_faq_a2(inputs)
	if (locale === "pt") return pt_bubble_faq_a2(inputs)
	if (locale === "ja") return ja_bubble_faq_a2(inputs)
	return zh_bubble_faq_a2(inputs)
};